import { SelectionDialogConfig } from './selection-dialog.component';

export const WAREHOUSE_SELECTION_CONFIG: SelectionDialogConfig = {
  type: 'warehouse',
  title: 'synchronization.warehouse.dialog.title',
  width: '88vw',
  maxWidth: '90vw',
  height: '85vh',
  maxHeight: '88vw',
  searchFields: [
    {
      key: 'code',
      label: 'synchronization.warehouse.search.warehouse_code',
      placeholder: 'synchronization.warehouse.search.warehouse_code_placeholder'
    },
    {
      key: 'name',
      label: 'synchronization.warehouse.search.warehouse_name',
      placeholder: 'synchronization.warehouse.search.warehouse_name_placeholder'
    }
  ],
  tableColumns: [
    {
      prop: 'code',
      label: 'synchronization.warehouse.table.warehouse_code',
      width: 100,
      type: 'text'
    },
    {
      prop: 'name',
      label: 'synchronization.warehouse.table.warehouse_name',
      width: 250,
      type: 'text'
    }
  ]
};

export const PRODUCT_SELECTION_CONFIG: SelectionDialogConfig = {
  type: 'product',
  title: 'synchronization.product.dialog.title',
  width: '88vw',
  maxWidth: '90vw',
  height: '85vh',
  maxHeight: '88vw',
  searchFields: [
    {
      key: 'productName',
      label: 'synchronization.product.search.product_name',
      placeholder: 'synchronization.product.search.product_name_placeholder'
    },
    {
      key: 'productCode',
      label: 'synchronization.product.search.product_code',
      placeholder: 'synchronization.product.search.product_code_placeholder'
    },
    {
      key: 'skuCode',
      label: 'synchronization.product.search.sku_code',
      placeholder: 'synchronization.product.search.sku_code_placeholder'
    }
  ],
  tableColumns: [
    {
      prop: 'categoryName',
      label: 'synchronization.product.table.product_category',
      width: 120,
      type: 'text'
    },
    {
      prop: 'spuCode',
      label: 'synchronization.product.table.product_code',
      width: 150,
      type: 'text'
    },
    {
      prop: 'spuName',
      label: 'synchronization.product.table.product_name',
      width: 220,
      type: 'text'
    },
    {
      prop: 'skuCode',
      label: 'synchronization.product.table.sku_code',
      width: 180,
      type: 'text'
    },
    {
      prop: 'skuName',
      label: 'synchronization.product.table.sku_name',
      width: 220,
      type: 'text'
    },
    {
      prop: 'productType',
      label: 'synchronization.product.table.product_type',
      width: 150,
      type: 'text'
    }
  ]
};
